const plhlPartnerIds = [
  403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 644, 656, 420, 418,
  430,
]

// 644 for dev
// 656 for hl dev

export const isPLHLPartner = ({ partnerId }: { partnerId: number }) => {
  return plhlPartnerIds.includes(partnerId)
}
